<template>
  <div class="my-home" :class="{ 'is-fullscreen': isFullscreen }">
    <!-- 右上角全屏按钮 -->
    <div
      class="fullscreen-btn"
      :title="isFullscreen ? '退出全屏' : '全屏显示'"
      @click="toggleFullscreen"
    >
      <svg-icon :icon-class="isFullscreen ? 'exit-fullscreen' : 'fullscreen'" />
    </div>

    <!-- ===== 主体区域（三栏式） ===== -->
    <div class="main-content">
      <!-- ===== 左侧区域（约22%） ===== -->
      <div class="left-panel">
        <!-- ④ 运营数据卡片 -->
        <div class="card">
          <div class="card-header">
            <i class="el-icon-data-line card-icon"></i>
            <!-- <h3 class="card-title">运营数据 <span class="card-subtitle">（本月）</span></h3> -->
            <h3 class="card-title">运营数据</h3>
          </div>
          <div class="kpi-list">
            <div v-for="(item, idx) in kpiData" :key="item.id + '_' + idx" class="kpi-card">
              <div class="kpi-icon" :style="{ background: item.iconBg }">
                <i :class="item.icon" :style="{ color: item.iconColor }"></i>
              </div>
              <div class="kpi-info">
                <p class="kpi-label">{{ item.label }}</p>
                <p class="kpi-value">
                  {{ item.value }} <span v-if="item.unit" class="kpi-unit">{{ item.unit }}</span>
                </p>
              </div>
              <span class="kpi-trend" v-if="item.trend && item.trend > 0">
                <i class="el-icon-top" v-if="item.trend != 0.001"></i>
                {{ `${item.trend === 0.001 ? '新增' : Math.abs(item.trend) + '%'}` }}
              </span>
              <span class="kpi-trend" style="color: #ef4444;" v-else-if="item.trend && item.trend < 0">
                <i class="el-icon-bottom"></i>
                {{ `${Math.abs(item.trend)} %` }}
              </span>
            </div>
          </div>
        </div>

        <!-- ① 设备概要数据卡片 -->
        <div class="card">
          <div class="card-header">
            <i class="el-icon-menu card-icon"></i>
            <h3 class="card-title">设备概要</h3>
          </div>
          <div class="device-tree">
            <div v-for="nodeL01 in deviceTree" :key="nodeL01.label" class="tree-node-wrapper">
              <div class="tree-node" @click="toggleNode(nodeL01)">
                <i v-if="nodeL01.children" :class="nodeL01.expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                  class="tree-arrow"></i>
                <span v-else class="tree-spacer"></span>
                <span class="tree-label">{{ nodeL01.label }}</span>
                <span class="tree-value" :style="{ color: nodeL01.color }">{{ nodeL01.value }}</span>
              </div>
              <div v-if="nodeL01.children && nodeL01.expanded" class="tree-children">
                <div v-for="nodeL02 in nodeL01.children" :key="nodeL02.label" class="tree-node-wrapper">
                  <div class="tree-node tree-node-l2" @click="toggleNode(nodeL02)">
                    <i v-if="nodeL02.children" :class="nodeL02.expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                      class="tree-arrow"></i>
                    <span v-else class="tree-spacer"></span>
                    <span class="tree-label">{{ nodeL02.label }}</span>
                    <span class="tree-value" :style="{ color: nodeL02.color }">{{ nodeL02.value }}</span>
                  </div>
                  <div v-if="nodeL02.children && nodeL02.expanded" class="tree-children">
                    <div v-for="nodeL03 in nodeL02.children" :key="nodeL03.label" class="tree-node-wrapper">
                      <div class="tree-node tree-node-l3" @click="toggleNode(nodeL03)">
                        <i v-if="nodeL03.children"
                          :class="nodeL03.expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                          class="tree-arrow"></i>
                        <span v-else class="tree-spacer"></span>
                        <span class="tree-label">{{ nodeL03.label }}</span>
                        <span class="tree-value" :style="{ color: nodeL03.color }">{{ nodeL03.value }}</span>
                      </div>
                      <div v-if="nodeL03.children && nodeL03.expanded" class="tree-children">
                        <div v-for="nodeL04 in nodeL03.children" :key="nodeL04.label" class="tree-node-wrapper">
                          <div class="tree-node tree-node-l4" @click="toggleNode(nodeL04)">
                            <i v-if="nodeL04.children"
                              :class="nodeL04.expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                              class="tree-arrow"></i>
                            <span v-else class="tree-spacer"></span>
                            <span class="tree-label">{{ nodeL04.label }}</span>
                            <span class="tree-value" :style="{ color: nodeL04.color }">{{ nodeL04.value }}</span>
                          </div>
                          <div v-if="nodeL04.children && nodeL04.expanded" class="tree-children">
                            <div v-for="nodeL05 in nodeL04.children" :key="nodeL05.label" class="tree-node-wrapper">
                              <div class="tree-node tree-node-l5">
                                <span class="tree-spacer"></span>
                                <span class="tree-label">{{ nodeL05.label }}</span>
                                <span class="tree-value" :style="{ color: nodeL05.color }">{{ nodeL05.value }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ===== 中间区域（约56%） ===== -->
      <div class="center-panel">
        <!-- ③ 湖南省地图 -->
        <div class="card map-card">
          <div class="map-header">
            <div>
              <div class="map-title">
                <i class="el-icon-map-location"></i>
                <span>湖南省充电站点分布</span>
              </div>
              <p class="map-subtitle">实时接入站点: {{ totalSitesNum }}个</p>
            </div>
          </div>
          <div ref="hunanMap" class="map-container"></div>
          <!-- 地图图例 -->
          <div class="map-legend">
            <div class="legend-title">站点密度</div>
            <div class="legend-item">
              <span class="legend-dot legend-dot-high"></span>
              <span>高密度（&gt;800个）</span>
            </div>
            <div class="legend-item">
              <span class="legend-dot legend-dot-mid"></span>
              <span>中密度（300-800个）</span>
            </div>
            <div class="legend-item">
              <span class="legend-dot legend-dot-low"></span>
              <span>低密度（&lt;300个）</span>
            </div>
          </div>
        </div>
      </div>

      <!-- ===== 右侧区域（约22%） ===== -->
      <div class="right-panel">
        <!-- ⑤ 调控信息卡片 -->
        <div class="card">
          <div class="card-header">
            <i class="el-icon-s-platform card-icon" style="color: #06b6d4"></i>
            <h3 class="card-title">调控概览</h3>
          </div>
          <div class="control-list">
            <div v-for="(item, idx) in controlData" :key="idx" class="control-item">
              <span class="control-label">{{ item.label }}</span>
              <span class="control-value">{{ item.value }}</span>
            </div>
          </div>
          <div class="power-mini">
            <div class="power-mini-header">
              <span class="power-mini-label">{{ 24 }} 小时功率曲线</span>
              <span class="power-mini-current">当前 <b>{{ this.currentPower }} kW</b></span>
            </div>
            <div ref="powerMiniChart" class="power-mini-chart"></div>
          </div>
        </div>

        <!-- ② 故障统计卡片 -->
        <div class="card fault-card">
          <div class="fault-header">
            <div class="card-header">
              <i class="el-icon-warning card-icon" style="color: #ef4444"></i>
              <h3 class="card-title">近五日故障统计</h3>
            </div>
            <!-- <span class="fault-badge">23 个</span> -->
          </div>
          <!-- <div ref="faultRingChart" class="fault-ring-chart"></div> -->
          <div class="fault-grid">
            <div class="fault-grid-item fault-grid-severe">
              <p class="fault-grid-value">{{ `${faultTjObj.level_two ? faultTjObj.level_two : "0"}` }}</p>
              <p class="fault-grid-label">报警</p>
            </div>
            <!-- <div class="fault-grid-item fault-grid-normal">
              <p class="fault-grid-value">12</p>
              <p class="fault-grid-label">一般</p>
            </div> -->
            <div class="fault-grid-item fault-grid-minor">
              <p class="fault-grid-value">{{ `${faultTjObj.level_one ? faultTjObj.level_one : "0"}` }}</p>
              <p class="fault-grid-label">预警</p>
            </div>
          </div>
          <div class="fault-list">
            <div v-for="(item, idx) in faultList" :key="idx" class="fault-item">
              <div class="fault-item-left">
                <span class="fault-time">{{ `${item.num} 次` }}</span>
                <el-tooltip effect="dark" :content="`${item.address} ${item.title}`" placement="top">
                  <span class="fault-desc">{{ `${item.address} ${item.title}` }}</span>
                </el-tooltip>
                <!-- <span class="fault-desc">{{ `${item.address} ${item.title}` }}</span> -->
              </div>
              <i class="el-icon-warning" :class="item.level > 1 ? 'fault-icon-red' : 'fault-icon-yellow'"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===== 底部区域（横跨全宽） ===== -->
    <div class="footer-content">
      <!-- ⑥ 充电月度趋势 -->
      <div class="card footer-trend">
        <div class="trend-header">
          <div class="card-header">
            <i class="el-icon-top card-icon"></i>
            <h3 class="card-title">用电月度趋势</h3>
          </div>
          <!-- <div class="trend-legend">
            <span class="trend-legend-item"><i class="trend-dot trend-dot-green"></i> 充电量</span>
            <span class="trend-legend-item"><i class="trend-dot trend-dot-yellow"></i> 环比增长率</span>
          </div> -->
        </div>
        <div ref="monthlyTrendChart" class="monthly-trend-chart"></div>
      </div>

      <!-- ⑦ 各站点运营排行 -->
      <div class="card footer-rank">
        <div class="card-header">
          <i class="el-icon-trophy card-icon" style="color: #f59e0b"></i>
          <h3 class="card-title">各站点运营排行 <span class="card-subtitle">Top 8</span></h3>
        </div>
        <div class="rank-table-wrapper">
          <table class="rank-table">
            <thead>
              <tr>
                <th class="rank-th rank-th-idx">#</th>
                <th class="rank-th rank-th-name">站点名称</th>
                <th class="rank-th rank-th-num">用电量(kWh)</th>
                <th class="rank-th rank-th-num">收入</th>
                <th class="rank-th rank-th-num">订单数</th>
                <th class="rank-th rank-th-num">用电时间(小时)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in rankData" :key="idx" class="rank-row">
                <td class="rank-td">
                  <span :class="['rank-idx', idx === 0 ? 'rank-idx-first' : '']">{{ idx + 1 }}</span>
                </td>
                <td class="rank-td rank-name">{{ item.power_site_name }}</td>
                <td class="rank-td rank-num">{{ formatReading(item.elect_power / 1000) }}</td>
                <td class="rank-td rank-num rank-income">{{ `¥${formatReading(item.elect_fee / 10000)}` }}</td>
                <td class="rank-td rank-num">{{ item.order_num }}</td>
                <td class="rank-td rank-num" :class="item.rateClass">{{ formatReading(item.all_charge_time / 60 / 60) }}
                </td>
                <!-- <td class="rank-td rank-num">
                  <i :class="item.trendIcon"></i>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts"
import screenfull from "screenfull"
import hunan from "../home/utils/hunan.json"
import {
  getHomeCurMonthBusiDataApi,
  getHomeAllSitesDataApi,
  getHomeDeviceTreeDataApi,
  getHomeUseElectChartDataApi,
  getHomeUseElectSiteYxPhDataApi,
  getHomeFualtTjDataApi,
  getHomeStrateDataApi
} from "@/api/data_statistic"

export default {
  name: "MyHome",
  data() {
    return {
      // 运营数据 KPI
      kpiData: [
        { id: "useElecty", label: "本月用电量", value: "*.**", unit: "kWh", trend: null, icon: "el-icon-lightning", iconColor: "#3b82f6", iconBg: "rgba(59,130,246,0.1)" },
        { id: "powerCost", label: "本月总电费", value: "*.**", unit: "", trend: null, icon: "el-icon-money", iconColor: "#10b981", iconBg: "rgba(16,185,129,0.1)" },
        { id: "servCost", label: "本月总服务费", value: "*.**", unit: "", trend: null, icon: "el-icon-tickets", iconColor: "#f59e0b", iconBg: "rgba(245,158,11,0.1)" },
        { id: "orderNum", label: "本月总订单数", value: "***", unit: "单", trend: null, icon: "el-icon-shopping-cart-2", iconColor: "#8b5cf6", iconBg: "rgba(139,92,246,0.1)" },
        { id: "chargeTime", label: "本月用电时间", value: "*.**", unit: "小时", trend: null, icon: "el-icon-odometer", iconColor: "#f43f5e", iconBg: "rgba(244,63,94,0.1)" },
        { id: "monthNewMeter", label: "本月开户数", value: "***", unit: "户", trend: null, icon: "el-icon-mobile", iconColor: "#10b981", iconBg: "rgba(16,185,129,0.1)" },
        { id: "totalNewMeter", label: "总开户数", value: "***", unit: "户", trend: null, icon: "el-icon-refrigerator", iconColor: "#8b5cf6", iconBg: "rgba(139,92,246,0.1)" },
        { id: "waitNewMeter", label: "剩余开户数", value: "***", unit: "户", trend: null, icon: "el-icon-tickets", iconColor: "#f59e0b", iconBg: "rgba(245,158,11,0.1)" }
      ],
      // 设备概要树
      deviceTree: [
        {
          label: "站点",
          value: "0 个",
          color: "#10b981",
          expanded: true,
          children: [
            {
              label: "台区",
              value: "0 个",
              color: "#3b82f6",
              expanded: true,
              children: [
                {
                  label: "一体柜",
                  value: "0 台",
                  color: "#06b6d4",
                  expanded: true,
                  children: [
                    {
                      label: "分支箱",
                      value: "0 个",
                      color: "#f97316",
                      expanded: true,
                      children: [{ label: "充电桩", value: "0 台", color: "#10b981" }]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      // 调控概览
      controlData: [
        { id: 'today_strate_num', label: "当日调控次数", value: "0 次" },
        { id: 'today_strate_power', label: "当日调控功率", value: "0 kW" },
      ],
      // 故障列表
      faultList: [
        // { time: "09:45", desc: "滨江充电中心站 #08桩 通讯异常", iconClass: "el-icon-warning fault-icon-yellow" },
        // { time: "08:32", desc: "城西枢纽站 #12桩 模块故障", iconClass: "el-icon-circle-close fault-icon-red" },
        // { time: "07:50", desc: "星沙站 A区-2台区 电压异常", iconClass: "el-icon-warning fault-icon-yellow" },
        // { time: "06:15", desc: "岳麓站 #05桩 急停按钮触发", iconClass: "el-icon-warning fault-icon-orange" },
        // { time: "昨日", desc: "高铁南站 总闸跳闸", iconClass: "el-icon-circle-close fault-icon-red" }
      ],
      faultTjObj: {},
      // 站点排行
      rankData: [],
      // 湖南省各个地级行政区域的散点数据(总共14个)
      stationScatterData: [
        { code: "430100", name: "长沙市", value: [112.982279, 28.19409, 0, 0] },
        { code: "430200", name: "株洲市", value: [113.281737, 27.535806, 0, 0] },
        { code: "430300", name: "湘潭市", value: [112.744052, 27.78973, 0, 0] },
        { code: "430400", name: "衡阳市", value: [112.607693, 26.900358, 0, 0] },
        { code: "430500", name: "邵阳市", value: [111.46923, 27.237842, 0, 0] },
        { code: "430600", name: "岳阳市", value: [113.132855, 29.37029, 0, 0] },
        { code: "430700", name: "常德市", value: [111.691347, 29.040225, 0, 0] },
        { code: "430800", name: "张家界市", value: [110.479921, 29.127401, 0, 0] },
        { code: "430900", name: "益阳市", value: [112.355042, 28.570066, 0, 0] },
        { code: "431000", name: "郴州市", value: [113.032067, 25.653589, 0, 0] },
        { code: "431100", name: "永州市", value: [111.608019, 26.434516, 0, 0] },
        { code: "431200", name: "怀化市", value: [109.97824, 27.390082, 0, 0] },
        { code: "431300", name: "娄底市", value: [111.908497, 27.728136, 0, 0] },
        { code: "433100", name: "湘西土家族苗族自治州", value: [109.739735, 28.314296, 0, 0] }
      ],
      totalSitesNum: 0,
      // ECharts 实例
      mapChart: null,
      faultChart: null,
      miniChart: null,
      trendChart: null,
      useElectyCategoryData: [],
      useElectySeriesData: [],
      controlChartXAxisLength: 24,
      controlChartSeriesData: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
      controlChartFullData: [],
      currentPower: '0.00',
      // 是否处于全屏状态
      isFullscreen: false,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initMap()
      //this.initFaultChart()
      this.initPowerMiniChart()
      this.initMonthlyTrendChart()
      this.getPageData()
    })
    window.addEventListener("resize", this.handleResize)
    // 监听全屏状态变化
    if (screenfull.enabled) {
      screenfull.on("change", this.changeFullscreen)
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)
    if (screenfull.enabled) {
      screenfull.off("change", this.changeFullscreen)
    }
    if (this.mapChart) {
      this.mapChart.dispose()
      this.mapChart = null
    }
    if (this.faultChart) {
      this.faultChart.dispose()
      this.faultChart = null
    }
    if (this.miniChart) {
      this.miniChart.dispose()
      this.miniChart = null
    }
    if (this.trendChart) {
      this.trendChart.dispose()
      this.trendChart = null
    }
  },
  methods: {
    formatReading(val) {
      if (val === null || val === undefined || val === "") return "0.00"
      return Number(val)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    getPageData() {
      this.getHomeCurMonthBusiData()
      this.getHomeAllSitesData()
      this.getHomeDeviceTreeData()
      this.getHomeUseElectChartData()
      this.getHomeUseElectSiteYxPhData()
      this.getHomeFualtTjData()
      this.getHomeStrateData()
    },
    getHomeCurMonthBusiData() {
      getHomeCurMonthBusiDataApi()
        .then((res) => {
          // console.log(res)
          const responeData = res.data || null
          if (responeData) {
            this.kpiData.forEach((item) => {
              switch (item.id) {
                case "useElecty":
                  item.value = this.formatReading(responeData.month_elec / 1000)
                  item.trend = responeData.month_elec_hb
                  break
                case "powerCost":
                  item.value = "¥" + this.formatReading(responeData.month_power_cost / 10000)
                  item.trend = responeData.month_power_cost_hb
                  break
                case "servCost":
                  item.value = "¥" + this.formatReading(responeData.month_serv_cost / 10000)
                  item.trend = responeData.month_serv_cost_hb
                  break
                case "orderNum":
                  item.value = responeData.month_order_nums
                  item.trend = responeData.month_order_nums_hb
                  break
                case "chargeTime":
                  item.value = this.formatReading(responeData.month_charge_time / 60 / 60)
                  item.trend = responeData.month_charge_time_hb
                  break
                case "monthNewMeter":
                  item.value = responeData.month_init_num
                  item.trend = responeData.month_init_num_hb
                  break
                case "totalNewMeter":
                  item.value = responeData.all_init_num
                  break
                case "waitNewMeter":
                  item.value = responeData.wait_init_num
                  break
              }
            })
          }
        })
        .catch((err) => {
          console.log("数据有误", JSON.stringify(err), err)
        })
        .finally(() => { })
    },
    getHomeAllSitesData() {
      getHomeAllSitesDataApi()
        .then((res) => {
          //console.log('湖南省充电站点分布',res)
          const responeData = res.data || []
          let totalNum = 0
          responeData.forEach((resItem) => {
            this.stationScatterData.some((item) => {
              if (resItem.city == item.code) {
                item.value[2] = resItem.num
              }
              return resItem.city == item.code
            })
            totalNum += resItem.num
          })
          this.totalSitesNum = totalNum
          this.updateMapChart()
        })
        .catch((err) => {
          console.log("数据有误", JSON.stringify(err), err)
        })
        .finally(() => { })
    },
    getHomeDeviceTreeData() {
      getHomeDeviceTreeDataApi()
        .then((res) => {
          //console.log('设备概要树',res)
          this.deviceTree = res || {}
        })
        .catch((err) => {
          console.log("数据有误", JSON.stringify(err), err)
        })
        .finally(() => { })
    },
    getHomeUseElectChartData() {
      getHomeUseElectChartDataApi()
        .then((res) => {
          // console.log(res)
          const backData = res.data || []
          let handleData = backData.map((item) => {
            const date = item.date_str // 日期
            const powerdata = (item.elect / 1000).toFixed(2) // 用电量

            return {
              date: date,
              electricity: powerdata
            }
          })
          this.selectDateData = handleData || []
          if (this.selectDateData && this.selectDateData.length > 0) {
            this.useElectyCategoryData = this.selectDateData.map((item) => item.date)
            this.useElectySeriesData = this.selectDateData.map((item) => item.electricity)
          } else {
            this.useElectyCategoryData = []
            this.useElectySeriesData = []
          }

          if (this.trendChart) {
            this.trendChart.setOption({
              xAxis: { data: this.useElectyCategoryData },
              series: [{ name: "用电量", data: this.useElectySeriesData }]
            })
          }
        })
        .catch((err) => {
          console.log("数据有误", JSON.stringify(err), err)
        })
        .finally(() => { })
    },
    getHomeUseElectSiteYxPhData() {
      getHomeUseElectSiteYxPhDataApi()
        .then((res) => {
          //console.log('排行榜数据',res)
          this.rankData = res.data || []
        })
        .catch((err) => {
          console.log("数据有误", JSON.stringify(err), err)
        })
        .finally(() => { })
    },
    getHomeFualtTjData() {
      getHomeFualtTjDataApi()
        .then((res) => {
          //console.log('故障统计数据',res)
          this.faultList = res.data || []
          this.faultTjObj = res.tj || {}
        })
        .catch((err) => {
          console.log("数据有误", JSON.stringify(err), err)
        })
        .finally(() => { })
    },
    getHomeStrateData() {
      getHomeStrateDataApi()
        .then((res) => {
          //console.log('调控功率数据', res)
          this.currentPower = this.formatReading(res.data.cur_total_power)
          const today_strate_num = res.data.today_strate_num > 0 ? `${res.data.today_strate_num}  次` : '0 次';
          const today_strate_power = res.data.today_strate_power > 0 ? `${res.data.today_strate_power}  kW` : '0.00 kW';
          this.controlData.forEach((item) => {
            if (item.id === 'today_strate_num') {
              item.value = today_strate_num;
            } else if (item.id === 'today_strate_power') {
              item.value = today_strate_power;
            }
          })
          const handleArrayData = res.data.chart_data || []
          //console.log(handleArrayData)

          this.controlChartXAxisLength = handleArrayData.length
          this.controlChartFullData = handleArrayData
          this.controlChartSeriesData = handleArrayData.map((item) => {
            return item.totalPower
          })
          this.updateMiniChart()

        })
        .catch((err) => {
          console.log("调控功率数据有误", JSON.stringify(err), err)
        })
        .finally(() => { })
    },
    handleResize() {
      this.mapChart && this.mapChart.resize()
      this.faultChart && this.faultChart.resize()
      this.miniChart && this.miniChart.resize()
      this.trendChart && this.trendChart.resize()
    },
    // ====== 全屏显示 ======
    // 点击图标：把当前页面全屏显示 / 退出全屏
    toggleFullscreen() {
      if (!screenfull.enabled) {
        this.$message({
          message: "当前浏览器不支持全屏",
          type: "warning"
        })
        return
      }
      // 以当前页面（.my-home）作为全屏元素
      screenfull.toggle(this.$el)
    },
    // 全屏状态变化
    changeFullscreen() {
      this.isFullscreen = screenfull.isFullscreen
      // 全屏切换后页面容器尺寸变化，重算图表尺寸
      this.$nextTick(() => {
        setTimeout(() => {
          this.handleResize()
        }, 200)
      })
    },
    toggleNode(node) {
      if (node.children) {
        this.$set(node, "expanded", !node.expanded)
      }
    },

    // ====== 湖南省地图 ======
    initMap() {
      const chartDom = this.$refs.hunanMap
      if (!chartDom) return
      echarts.registerMap("hunan", hunan)
      this.mapChart = echarts.init(chartDom)

      //this.updateMapChart()
    },

    updateMapChart() {
      if (!this.mapChart) return
      let that = this;
      const option = {
        backgroundColor: "transparent",
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          borderColor: "rgba(16, 185, 129, 0.3)",
          textStyle: { color: "#1e293b", fontSize: 12 },

          formatter: (params) => {
            if (!params.data) return params.name
            const d = params.data

            // <p style="font-size:12px;color:#64748b;">日充电量: <span style="color:#059669;font-family:monospace;">${d.value[3].toLocaleString()}</span> kWh</p>
            return `<div style="padding:4px 8px;">
              <p style="font-weight:600;color:#059669;margin-bottom:4px;border-bottom:1px solid #e2e8f0;padding-bottom:4px;">${d.name}</p>
              <p style="font-size:12px;color:#64748b;">站点数: <span style="color:#059669;font-family:monospace;">${d.value[2].toLocaleString()}</span> 个</p>
            </div>`
          }
        },
        geo: {
          map: "hunan",
          roam: false,
          zoom: 1.05,
          center: [111.5, 27.5],

          label: {
            show: true,
            color: "rgba(71, 85, 105, 0.6)",
            fontSize: 10
          },
          itemStyle: {
            areaColor: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: "rgba(209, 250, 229, 0.6)" },
                { offset: 0.5, color: "rgba(167, 243, 208, 0.4)" },
                { offset: 1, color: "rgba(209, 250, 229, 0.6)" }
              ],
              global: false
            },
            borderColor: "rgba(16, 185, 129, 0.4)",
            borderWidth: 1.5,
            shadowColor: "rgba(16, 185, 129, 0.08)",
            shadowBlur: 10
          },
          emphasis: {
            itemStyle: {
              areaColor: "rgba(167, 243, 208, 0.5)",
              borderColor: "#059669"
            },
            label: { color: "#064e3b", fontSize: 12 }
          }
        },
        series: [
          {
            name: "充电站点",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: this.stationScatterData,
            // symbolSize: (val) => Math.max(8, Math.sqrt(val[2]) * 0.25),
            symbolSize: (val) => {
              return Math.max(11, Math.min(val[2] / 37, 30))
            },
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
              scale: 2.5,
              period: 2,
              color: "rgba(16, 185, 129, 0.3)"
            },
            label: { show: false },
            itemStyle: {
              /* color: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.5,
                colorStops: [
                  { offset: 0, color: "rgba(52, 211, 153, 0.9)" },
                  { offset: 1, color: "rgba(16, 185, 129, 0.3)" }
                ]
              }, */
              color: function (params) {
                const num = params.value[2];
                //console.log('设置颜色时 params= ' + JSON.stringify(params));
                //console.log(`设置颜色时，${params.name}的站点数：${num}`);
                if (num < 300) return that.createRadial(4, 120, 87);
                else if (num < 800) return that.createRadial(5, 150, 105);
                else return that.createRadial(16, 185, 129);
              },
              shadowBlur: 12,
              shadowColor: "rgba(16, 185, 129, 0.4)",
              borderColor: "#10b981",
              borderWidth: 1
            },
            zlevel: 2
          }
        ]
      }
      this.mapChart.setOption(option)
    },
    createRadial(r, g, b) {
      return {
        type: "radial",
        x: 0.5,
        y: 0.5,
        r: 0.5,
        colorStops: [
          { offset: 0, color: `rgba(${r}, ${g}, ${b}, 1)` },
          { offset: 1, color: `rgba(${r}, ${g}, ${b}, 0.8)` }
        ]
      }
    },
    // ====== 故障环形图 ======
    initFaultChart() {
      const chartDom = this.$refs.faultRingChart
      if (!chartDom) return
      this.faultChart = echarts.init(chartDom)
      this.faultChart.setOption({
        backgroundColor: "transparent",
        tooltip: { show: false },
        series: [
          {
            type: "pie",
            radius: ["55%", "75%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            label: { show: false },
            labelLine: { show: false },
            data: [
              { value: 5, name: "严重", itemStyle: { color: "#ef4444" } },
              { value: 12, name: "一般", itemStyle: { color: "#f97316" } },
              { value: 6, name: "轻微", itemStyle: { color: "#eab308" } }
            ]
          }
        ]
      })
    },

    // ====== 24h 功率迷你图 ======
    initPowerMiniChart() {
      let that = this;
      const chartDom = this.$refs.powerMiniChart
      if (!chartDom) return
      this.miniChart = echarts.init(chartDom)
      this.miniChart.setOption({
        backgroundColor: "transparent",
        grid: { left: "1%", right: "1%", top: "5%", bottom: "5%" },
        xAxis: {
          type: "category",
          data: that.controlChartFullData.length
            ? that.controlChartFullData.map((item) => item.date_time)
            : Array.from({ length: that.controlChartXAxisLength }, (_, i) => i + "h"),
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: { show: false },
          splitLine: { show: false }
        },
        yAxis: {
          type: "value",
          splitLine: { show: false },
          axisLabel: { show: false },
          axisLine: { show: false },
          axisTick: { show: false }
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          borderColor: "rgba(8, 145, 178, 0.3)",
          borderWidth: 1,
          padding: 6,
          textStyle: { color: "#1e293b", fontSize: 11 },
          formatter: (params) => {
            const p = params[0]
            return `<div style="padding:2px 4px;">
              <p style="font-size:11px;color:#64748b;margin:0;">${p.axisValue} 功率</p>
              <p style="font-size:13px;font-weight:600;color:#0891b2;margin:3px 0 0;font-family:monospace;">${p.data} kW</p>
            </div>`
          }
        },
        series: [
          {
            type: "line",
            smooth: true,
            showSymbol: false,
            lineStyle: {
              color: "#0891b2",
              width: 2,
              shadowBlur: 4,
              shadowColor: "rgba(8, 145, 178, 0.2)"
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: "rgba(8, 145, 178, 0.2)" },
                  { offset: 1, color: "rgba(8, 145, 178, 0.01)" }
                ]
              }
            },
            data: that.controlChartSeriesData
          }
        ]
      })
    },

    // ====== 月度趋势折线图 ======
    initMonthlyTrendChart() {
      const chartDom = this.$refs.monthlyTrendChart
      if (!chartDom) return
      this.trendChart = echarts.init(chartDom)
      this.trendChart.setOption({
        backgroundColor: "transparent",
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderColor: "rgba(203, 213, 225, 0.5)",
          textStyle: { color: "#1e293b", fontSize: 11 },
          axisPointer: { type: "cross", label: { backgroundColor: "#e2e8f0" } }
        },
        legend: {
          data: ["用电量"],
          textStyle: { color: "#64748b", fontSize: 10 },
          icon: "circle",
          itemWidth: 8,
          itemHeight: 8,
          top: -2,
          right: 0
        },
        grid: { top: "18%", left: "3%", right: "4%", bottom: "8%", containLabel: true },
        xAxis: {
          type: "category",
          //data: ["1月", "2月", "3月", "4月", "5月"],
          data: this.useElectyCategoryData,
          axisLine: { lineStyle: { color: "#cbd5e1" } },
          axisLabel: { color: "#64748b", fontSize: 10 }
        },
        yAxis: [
          {
            type: "value",
            name: "kWh",
            nameTextStyle: { color: "#64748b", fontSize: 10 },
            splitLine: { lineStyle: { color: "rgba(203, 213, 225, 0.5)", type: "dashed" } },
            axisLabel: { color: "#64748b", fontSize: 10 }
          }
        ],
        series: [
          {
            name: "用电量",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 8,
            //data: [98, 112, 128, 145, 162],
            data: this.useElectySeriesData,
            itemStyle: { color: "#059669" },
            lineStyle: { width: 3, shadowBlur: 6, shadowColor: "rgba(16, 185, 129, 0.2)" },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                colorStops: [{ offset: 0, color: "rgba(16, 185, 129, 0.15)" }]
              }
            }
          }
        ]
      })
    },
    // 更Mini新图表数据
    updateMiniChart() {
      if (this.miniChart) {
        this.miniChart.setOption({
          xAxis: { data: this.controlChartFullData.map((item) => item.date_time) },
          series: {
            data: this.controlChartSeriesData
          }
        })
      }
    }

  }
}
</script>

<style scoped lang="scss">
.my-home {
  position: relative;
  padding: 16px;
  background-color: #f5f7fa;
  height: calc(100vh - 80px);
  overflow-y: auto;
  box-sizing: border-box;
}

/* 全屏时占满整个屏幕 */
.my-home.is-fullscreen {
  height: 100vh;
  margin: 0;
}

/* ===== 右上角全屏按钮 ===== */
.fullscreen-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 20;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: rgba(255, 255, 255, 0.9);
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    color: #10b981;
    border-color: rgba(16, 185, 129, 0.5);
    background: rgba(16, 185, 129, 0.08);
  }

  .svg-icon {
    width: 18px;
    height: 18px;
  }
}

/* ===== 通用卡片 ===== */
.card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.card-icon {
  font-size: 18px;
  color: #10b981;
}

.card-title {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.card-subtitle {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 400;
}

/* ===== 主体三栏 ===== */
.main-content {
  display: flex;
  gap: 16px;
  min-height: 520px;
  margin-bottom: 0;
}

.left-panel {
  width: 22%;
  flex-shrink: 0;
}

.center-panel {
  flex: 1;
  min-width: 0;
}

.right-panel {
  width: 22%;
  flex-shrink: 0;
}

/* ===== KPI 卡片 ===== */
.kpi-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.kpi-card {
  display: flex;
  align-items: center;
  padding: 9px 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.2s ease;

  &:hover {
    border-color: rgba(16, 185, 129, 0.4);
    transform: translateY(-1px);
  }
}

.kpi-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
  font-size: 18px;
}

.kpi-info {
  flex: 1;
  min-width: 0;
}

.kpi-label {
  font-size: 12px;
  color: #64748b;
  margin: 0;
}

.kpi-value {
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  margin: 3px 0 0 0;
}

.kpi-unit {
  font-size: 12px;
  font-weight: 400;
  color: #94a3b8;
}

.kpi-trend {
  font-size: 12px;
  color: #10b981;
  flex-shrink: 0;

  i {
    font-size: 12px;
    margin-right: 2px;
  }
}

/* ===== 设备树 ===== */
.device-tree {
  font-size: 13px;
}

.tree-node-wrapper {
  width: 100%;
}

.tree-node {
  display: flex;
  align-items: center;
  padding: 6px 6px 6px 3px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: rgba(16, 185, 129, 0.06);
  }
}

.tree-node-l2 {
  padding-left: 13px;
}

.tree-node-l3 {
  padding-left: 25px;
}

.tree-node-l4 {
  padding-left: 37px;
}

.tree-node-l5 {
  padding-left: 49px;
}

.tree-arrow {
  font-size: 12px;
  color: #94a3b8;
  margin-right: 6px;
  width: 14px;
  text-align: center;
}

.tree-spacer {
  width: 6px;
  margin-right: 6px;
  display: inline-block;
}

.tree-label {
  color: #374151;
  font-weight: 500;
}

.tree-value {
  margin-left: auto;
  font-weight: 700;
  font-family: monospace;
}

.tree-children {
  overflow: hidden;
}

/* ===== 地图卡片 ===== */
.map-card {
  height: 92%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.map-header {
  position: relative;
  z-index: 2;
  margin-bottom: 8px;
}

.map-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  font-weight: 600;
  color: #374151;

  i {
    color: #10b981;
    font-size: 18px;
  }
}

.map-subtitle {
  font-size: 12px;
  color: #64748b;
  margin: 8px 0 0;
}

.map-container {
  flex: 1;
  min-height: 320px;
}

.map-legend {
  position: absolute;
  bottom: 16px;
  right: 16px;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(6px);
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  z-index: 2;
  font-size: 12px;
  color: #64748b;
}

.legend-title {
  margin-bottom: 6px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }
}

.legend-dot {
  border-radius: 50%;
  display: inline-block;
}

.legend-dot-high {
  width: 12px;
  height: 12px;
  background: #10b981;
  box-shadow: 0 0 6px #10b981;
}

.legend-dot-mid {
  width: 10px;
  height: 10px;
  margin: 1px;
  background: #059669;
}

.legend-dot-low {
  width: 8px;
  height: 8px;
  margin: 2px;
  background: #047857;
}

/* ===== 调控概览 ===== */
.control-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.control-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  background: #f8fafc;
  border-radius: 8px;
}

.control-label {
  font-size: 12px;
  color: #64748b;
}

.control-value {
  font-size: 15px;
  font-weight: 700;
  color: #0891b2;
  font-family: monospace;
}

.power-mini {
  padding-top: 8px;
}

.power-mini-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.power-mini-label {
  font-size: 12px;
  color: #64748b;
}

.power-mini-current {
  font-size: 12px;
  color: #64748b;

  b {
    color: #0891b2;
    font-family: monospace;
  }
}

.power-mini-chart {
  width: 100%;
  height: 60px;
}

/* ===== 故障统计 ===== */
.fault-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 460px;
}

.fault-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;

  .card-header {
    margin-bottom: 0;
  }
}

.fault-badge {
  font-size: 12px;
  background: rgba(239, 68, 68, 0.08);
  color: #ef4444;
  padding: 2px 10px;
  border-radius: 100px;
  border: 1px solid #fecaca;
  font-family: monospace;
}

.fault-ring-chart {
  width: 100%;
  height: 120px;
}

.fault-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 12px;
  text-align: center;
  font-size: 12px;
}

.fault-grid-item {
  padding: 8px 0;
  border-radius: 8px;
  border: 1px solid;
}

.fault-grid-severe {
  background: #fef2f2;
  border-color: #fecaca;

  .fault-grid-value {
    color: #ef4444;
  }
}

.fault-grid-normal {
  background: #fff7ed;
  border-color: #fed7aa;

  .fault-grid-value {
    color: #f97316;
  }
}

.fault-grid-minor {
  background: #fefce8;
  border-color: #fde68a;

  .fault-grid-value {
    color: #ca8a04;
  }
}

.fault-grid-value {
  font-size: 18px;
  font-weight: 700;
  margin: 0;
}

.fault-grid-label {
  color: #64748b;
  margin: 4px 0 0 0;
}

.fault-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.fault-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  border-radius: 6px;
  background: #f8fafc;
  font-size: 12px;
  transition: background 0.2s;

  &:hover {
    background: #f1f5f9;
  }
}

.fault-item-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.fault-time {
  color: #64748b;
  font-family: monospace;
  width: 52px;
  flex-shrink: 0;
}

.fault-desc {
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
}

.fault-icon-yellow {
  color: #eab308;
}

.fault-icon-red {
  color: #ef4444;
}

.fault-icon-orange {
  color: #f97316;
}

/* ===== 底部区域 ===== */
.footer-content {
  display: flex;
  gap: 16px;
  margin-top: 16px;
  margin-bottom: 88px;
  min-height: 340px;
}

.footer-trend {
  flex: 58;
}

.footer-rank {
  flex: 42;
}

.footer-content>.card {
  margin-bottom: 0;
}

/* 趋势图 */
.trend-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  .card-header {
    margin-bottom: 0;
  }
}

.trend-legend {
  display: flex;
  gap: 14px;
  font-size: 12px;
  color: #64748b;
}

.trend-legend-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.trend-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.trend-dot-green {
  background: #10b981;
}

.trend-dot-yellow {
  background: #facc15;
}

.monthly-trend-chart {
  width: 100%;
  height: 90%;
}

/* ===== 排行表格 ===== */
.rank-table-wrapper {
  overflow-x: auto;
}

.rank-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.rank-th {
  color: #64748b;
  font-weight: 500;
  padding: 8px 6px;
  border-bottom: 1px solid #e2e8f0;
  text-align: right;
}

.rank-th-idx {
  text-align: left;
  width: 28px;
}

.rank-th-name {
  text-align: left;
}

.rank-row {
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.15s;

  &:hover {
    background: rgba(16, 185, 129, 0.04);
  }

  &:last-child {
    border-bottom: none;
  }
}

.rank-td {
  padding: 8px 6px;
  color: #374151;
  text-align: right;
  font-family: monospace;
}

.rank-name {
  text-align: left;
  font-family: inherit;
  color: #374151;
}

.rank-num {
  font-family: monospace;
}

.rank-idx {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  background: #f1f5f9;
  color: #64748b;
}

.rank-idx-first {
  background: rgba(16, 185, 129, 0.12);
  color: #059669;
}

.rank-income {
  color: #059669;
}

.rate-good {
  color: #059669;
}

.rate-bad {
  color: #ef4444;
}

.rate-warn {
  color: #ca8a04;
}

.rank-trend-up {
  color: #10b981;
  font-size: 14px;
}

.rank-trend-down {
  color: #ef4444;
  font-size: 14px;
}

.rank-trend-flat {
  color: #94a3b8;
  font-size: 14px;
}
</style>
